function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import * as IconSet from "../../../../icons/index.js";
import Icon from "../../../basic/Icon/Icon.js";
import { FieldSizes, Indicators } from "../constants.js";
import { getIndicatorIconSize } from "../helpers.js";
/* Removal icon for multi-value badge/pill */

var StyledMultiValueRemove = styled(Icon).withConfig({
  componentId: "CL__sc-14c2em1-0"
})(["&&{background:transparent;border-radius:var(--border-radius-small);color:var(--text-color);cursor:pointer;padding:0 3px 0 0;transition:color var(--hover-transition),opacity var(--hover-transition);}&&:focus{outline:none;}&&:hover{background-color:transparent;color:var(--red-6);}&&:focus-visible{box-shadow:0 0 0 6px var(--surface-bkg-color);outline:2px solid var(--text-color);outline-offset:2px;}"]);
var MultiValueRemove = props => {
  var {
      selectProps
    } = props,
    restInnerProps = _extends({}, (_objectDestructuringEmpty(props.innerProps), props.innerProps));
  var fieldSize = selectProps.fieldSize || FieldSizes.MEDIUM;
  return /*#__PURE__*/React.createElement(StyledMultiValueRemove, _extends({
    component: IconSet.Close,
    size: getIndicatorIconSize(fieldSize, Indicators.MULTI_VALUE_REMOVE),
    tabIndex: 0
  }, restInnerProps));
};
export default MultiValueRemove;